export default {
  title: '用户隐私服务条款',
  content:
    '    <p>\n' +
      '    欢迎您使用识道网络（以下也称“我方”或“我们”），识道网络由河北识道网络科技有限公司备案运营。为给您提供更准确的服务和更安全的网络环境，您在使用我方的服务时，我方可能会收集和处理您的相关信息。您的信任对我们非常重要，我们深知用户信息安全的重要性，我们将按照《中华人民共和国网络安全法》、《信息安全技术个人信息安全规范》以及其他相关法律法规和技术规范要求，采取安全保护措施，保护您的个人信息。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>\n' +
      '        鉴此，识道网络制定本《隐私服务条款》(以下也称“本政策”或“本隐私政策”)并提醒您：在使用识道网络的各项服务前，请您务必仔细阅读并透彻理解本政策，在确认充分理解并同意后方使用相关产品和服务。如果您不同意本政策任何内容，请您立即停止使用识道网络各项服务和产品尤其是涉及交易往来的服务和产品。当您使用识道网络提供的任一服务时，即表示您已充分阅读、理解并同意我们按照本政策的约定收集、使用、存储和保护您的相关信息。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>特别提示：本《隐私服务条款》将于发布之日正式生效，除非我方根据相关法律法规及运营平台对本隐私政策作出调整并发布新的隐私政策，否则本隐私政策一直有效。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>本隐私政策帮助您了解以下内容：</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>一、本政策的适用范围</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>二、我方如何收集和使用您的个人信息</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>三、我方如何共享、转让、公开披露您的个人信息</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>四、您如何管理自己的信息及账号注销</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>五、我方如何存储和保护您的个人信息</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>六、我方如何处理未成年人的个人信息</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>七、免责声明(重要条款，请仔细阅读)</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>八、通知和修订</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>九、联系我们</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>一、本政策的适用范围</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>1.1本政策适用于河北识道网络科技有限公司旗下的所有产品和服务，如您对本政策或相关事宜内容有任何疑问、意见或建议，您可随时通过官方客服与我方联系。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>1.2若您通过使用河北识道网络科技有限公司提供的产品和服务为您的用户再行提供服务，您应当与您的用户另行签订用户服务协议与隐私服务条款。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>二、我方如何收集和使用您的个人信息</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>2.1个人信息定义及范围</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>\n' +
      '        2.1.1个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息，包括姓名、出生日期、身份证件号码、个人生物识别信息、住址、通信通讯联系方式、通信记录和内容、账号密码、财产信息、征信信息、行踪轨迹、住宿信息、健康生理信息、交易信息等。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>\n' +
      '        个人敏感信息是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息，包括身份证件号码、个人生物识别信息、银行账户、通信记录和内容、财产信息、征信信息、行踪轨迹、住宿信息、健康生理信息、交易信息、14岁以下（含）儿童的个人信息等。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> 2.1.2本隐私政策中涉及的个人信息包括但不限于（其中，字体加粗部分涉及个人敏感信息）：</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> （1）个人基本资料（包括个人姓名、个人电话号码、电子邮件地址等）；</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> （2）个人身份信息（包括身份证等）；个人生物识别信息（包括面部识别特征等）;</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> （3）日志信息（当您使用我们的网站或客户端提供的服务时，我们会自动收集您对我们服务的详细使用情况，作为有关网络日志保存，包括个人信息主体账号、IP地址、个人数字证书、网站浏览记录、点击记录、收藏列表等）；</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> （4）个人财产信息（包括交易与消费记录、资金明细等）；</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> （5）个人上网记录（包括网站浏览记录、平台使用记录、操作记录、登录记录、收藏列表）；</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> （6）个人常用设备信息（包括硬件型号、操作系统类型等在内的描述个人常用设备基本情况的信息）。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>2.2我方仅会出于以下目的，收集和使用您的个人信息：</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>\n' +
      '        您须授权我方收集和使用您个人信息的情形：我方的服务包括核心业务功能和附加功能，其中，核心功能包含了实现域名交易所必须的功能、改进我方的服务所必须的功能及保障交易安全所必须的功能。我方可能会收集和使用下列与您有关的信息才能实现上述这些功能。如果您不提供相关信息，您将无法享受我方提供的核心服务。其中，主要包括成为我方用户和使用我方提供的技术服务：</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> 2.2.1实现域名交易所必须的功能</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> （1）账户注册</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>\n' +
      '        您首先需要注册一个识道网络账户以成为识道网络用户。当您注册时，您需要至少向我方提供您准备使用的账户邮箱、设置登录密码、QQ号码、您本人在中华人民共和国境内手机号码等，这些信息均属于您的账户信息，我们将通过邮件的方式来验证您的身份是否有效，我方可能会利用如上方式向您推广、宣传产品、邮寄业务通知（含发票）或与您进行业务沟通。另，您账户绑定的手机号和账户邮箱，作为我方与您联系的方式之一，用来接受相关业务通知。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> （2）身份验证</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> A.实名验证</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> 根据《中华人民共和国网络安全法》、《互联网域名管理办法》以及其他相关法律法规规定，在您使用具体的技术服务前，通过您的账号提供您的手机号、姓名、身份证件号码（个人敏感信息），完成账户实名认证。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> B.重要操作行为验证</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>\n' +
      '        为了提高您使用我方或我方关联公司或合作授权伙伴提供服务的安全性，更准确地识别违反法律法规或识道网络相关协议及规则的情况，我们可能会通过人脸识别等来判断您的账户操作及交易风险，进行身份验证，并依法采取必要的记录，采取审计、分析和处置等措施。比如在您进行一些重要账户操作时（如找回密码、申请提现、申请开票、操作保护等）您可能需要向我们提供姓名、邮箱号码、QQ号、身份证照片（个人敏感信息）以及其他在具体业务开展中基于您的同意而收集到的可识别您身份的证明材料，如您不同意提供前述信息，您将无法完成特定操作，但不影响您使用我们提供的其他服务。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> （3）支付功能</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>\n' +
      '        在您付款时，您可以选择我方的关联方或与我方合作的第三方支付机构（包括支付宝等支付通道）所提供的支付服务。支付功能本身并不收集您的个人信息，但我方需要将您在识道网络上的订单号与交易金额信息（个人敏感信息）与这些支付机构共享以实现其确认您的支付指令并完成支付。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> （4）资金明细</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>\n' +
      '        为展示您账号下的资金明细，我们会收集您在使用我们服务过程中产生的订单信息用于向您展示。您在识道网络生成的订单中，将可能包含您的账户信息、支付信息、流水记录等，这些都属于个人敏感信息，请您谨慎向他人展示或对外提供，如识道网络需对外提供订单信息时，将取得您的授权，并尽到合理商业注意义务对您的信息进行去标识化处理以在最大化保护您的个人信息的同时实现信息可用性。其中，字体加粗部分涉及个人敏感信息。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> （5）客服与售后服务</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>\n' +
      '        当您与我方的客服取得联系时，我方的系统可能会记录您与客服之间的通讯记录，以及使用您的账号信息以便核验身份；当您需要我方提供与您订单相关的客户服务时，我方可能会查询您的相关订单信息以便给予您适当的帮助和处理；当您需要客服协助您修改有关信息（如身份信息、联系方式）时，您可能还需要提供上述信息外的其他信息以便完成修改。其中，字体加粗部分涉及个人敏感信息。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> 2.2.2改进我方的服务所必须的功能</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> 我方可能会收集您使用我方的服务的设备信息、浏览器类型来为您提供展示界面的最优方式。我方也会为了不断改进和优化上述的功能来使用您的上述个人信息。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> 2.2.3保障交易安全所必须的功能</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> （1）日志信息</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>\n' +
      '        根据《中华人民共和国网络安全法》的规定，网络服务提供者保存网路日志不少于六个月。当您使用我方的服务时，我方可能会收集您对我们服务的详细使用情况，作为有关网络日志保存。例如您的个人信息主体账号、IP地址、个人数字证书、网站浏览记录、软件使用记录、点击记录、收藏列表、群组列表等，以上加粗部分为您的个人敏感信息。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> （2）安全保障</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>\n' +
      '        为预防、发现、调查欺诈、侵权、危害安全、非法或违反与我方或与我方关联公司的协议、政策或规则的行为，我方可能收集或整合您的用户信息、服务使用信息、设备信息、日志信息以及我方关联公司、合作伙伴取得您授权或依据法律共享的信息。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> 2.2.4征得授权同意的例外</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> 根据法律法规规定，以下情形中收集您的个人信息无需征得您的授权同意：</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> （1）与国家安全、国防安全有关的；</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> （2）与公共安全、公共卫生、重大公共利益有关的；</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> （3）与犯罪侦查、起诉、审判和判决执行以及民事仲裁诉讼等有关的；</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> （4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> （5）所收集的信息是您自行向社会公众公开的；</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> （6）从合法公开披露的信息中收集信息的，如我方或第三方合法的新闻报道、政府信息公开等渠道；</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>（7）根据您的要求签订合同所必需的；</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>（8）用于维护识道网络服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>（9）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的信息进行去标识化处理的；</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>（10）法律法规规定的其他情形。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>2.3信息使用的方式</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>收集您的信息是为了向您提供服务及提升服务质量，为了实现这一目的，您的信息将用于下列用途，如我们需将收集到的相关信息用于新的目的、范围。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> 2.3.1优化服务</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> 向您提供您使用的识道网络产品或服务，并维护、改进、优化这些服务及服务体验。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> 2.3.2保障账号安全</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>\n' +
      '        为预防、发现、调查欺诈、侵权、危害安全、非法或违反与我们或与我们关联公司的协议、政策或规则的行为，保护您、其他用户或公众，我们或我们关联公司的合法权益，我们可能使用或整合您的用户信息、服务使用信息、设备信息、日志信息以及我们关联公司、合作伙伴取得您授权或依据法律共享的信息，来综合判断您账号及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> 2.3.3经您许可的其他用途</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> 2.3.4识道网络权限使用及使用情况说明</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> 为保障识道网络能实现与安全稳定运行之目的，我们可能会申请或使用操作系统的相关权限；为保障您的知情权，我们通过下列列表将产品可能申请、使用的相关操作系统权限进行展示，您可以根据实际需要对相关权限进行管理。 </p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>三、我方如何共享、转让、公开披露您的个人信息</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>3.1 共享</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> 3.1.1我方不会与识道网络运营主体以外的任何公司、组织和个人共享您的个人信息，但以下情况除外：</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> （1） 在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的用户信息：</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>\n' +
      '        A.与关联公司间共享：为便于我们基于关联账号共同向您提供服务，推荐您可能感兴趣的信息或保护识道网络关联公司或其他用户或公众的人身财产安全免遭侵害，您的个人信息可能会与我们的关联公司共享。我们只会共享必要的个人信息（如为便于您通过识道网络账号使用我们关联公司产品或服务，我们会向关联公司共享您必要的账号信息），如果我们共享您的个人敏感信息或关联公司改变个人信息的使用及处理目的，将再次征求您的授权同意。您同意关联公司与识道网络共享服务必要的相关信息，识道网络将准确记录和保存个人信息的共享、转让的情况，包括共享、转让的日期、规模、目的，以及数据接收方基本情况。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>\n' +
      '        B.与授权合作伙伴共享：我们可能委托受信赖的合作伙伴来提供服务，因此我们可能会与合作伙伴共享您的某些用户信息，以提供更好的客户服务和优化用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的用户信息，并且只会共享提供服务所必要的用户信息。我们的合作伙伴无权将共享的用户信息用于任何其他用途。您同意识道网络与如下第三方共享个人信息：</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>\n' +
      '        a.我们可能会将您的个人信息共享给支持我们功能的供应商。这些支持包括为我们供货或提供基础设施技术服务、支付服务、数据处理、人脸识别认证等。我们共享这些信息的目的是可以实现我们产品与/或服务的核心功能，比如我们必须与技术服务商共享您的个人姓名、身份证号码、脸部识别特征才能进行您的身份验证，为了促成交易或协助解决争议，某些情况下只有共享您的用户信息，才能促成交易或处理您与他人的纠纷或争议等。（加粗部分为个人敏感信息）</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> b.为了遵守法律、执行或适用我方的使用条件和其他协议，或者为了保护识道网络、您或其他识道网络客户的权利及其财产或安全，比如为防止欺诈等违法活动和减少信用风险，而与其他公司和组织交换信息。不过,\n' +
      '        这并不包括违反本隐私政策中所作的承诺而为获利目的出售、出租、共享或以其它方式披露的个人信息。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>（2） 在法定情形下的共享：我们可能会根据法律法规规定、诉讼、仲裁解决需要，或按行政、司法机关依法提出的要求，对外共享您的用户信息。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>3.1.2对我们与之共享用户信息的公司、组织和个人，我们会与其签署严格的保密协议以及信息保护约定，要求他们按照我们的说明、本隐私权政策以及其他任何相关的保密和安全措施来处理用户信息。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>3.2 转让</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>我方不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>（1）在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的用户信息;</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>\n' +
      '        （2）在识道网络运营主体河北识道网络科技有限公司与其他法律主体者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到用户信息转让，我们会要求新的持有您用户信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>3.3 公开披露</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>我们仅会在以下情况下，公开披露您的用户信息：</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>（1） 获得您明确同意或基于您的主动选择，我们可能会公开披露您的用户信息;</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>（2）\n' +
      '        或为保护识道网络平台及其关联公司用户或公众的人身财产安全免遭侵害，我们可能依据适用的法律或识道网络平台相关协议、规则披露关于您的用户信息。例如，若店铺涉及违规或您作为用户恶意扰乱正常交易，我们可能会公开披露您的信息与处罚情况。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>3.4 例外情形</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>以下情形中，共享、转让、公开披露您的用户信息无需事先征得您的授权同意：</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>（1）与国家安全、国防安全、公共安全、重大公共利益有关的；</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>（2）与犯罪侦查、起诉、审判和判决执行、民事仲裁和诉讼等有关的；</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>（3）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>（4）您自行向社会公众公开的个人信息；</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>（5）为了促成交易或协助解决争议，某些情况下只有共享您的用户信息，才能促成交易或处理您与他人的纠纷或争议等；</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>\n' +
      '        （6）从合法公开披露的信息中收集信息的，如合法的新闻报道、政府信息公开等渠道。根据法律规定，共享、转让经去标识化处理的信息，且确保数据接收方无法复原并重新识别信息主体的，不属于信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>（7）为方便用户进行域名交易与管理，河北识道网络科技有限公司需将用户提交的信息，递交给第三方域名注册商平台同步认证。。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>四、您如何管理自己的信息及账号注销</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>4.1访问和更正您的个人信息</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>\n' +
      '        如您可以通过识道网络选择（进入“会员中心”菜单页，选择“账号管理”模块）查看您的账号个人资料信息、更改您的密码、添加操作保护设置等。如果您需要变更账户实名认证信息，您需通过在线客服联系，按照我方格式程序要求操作，同时不得违反相关法律法规和我司平台规定。如有任何问题，您可以通过识道网络的官方客服渠道联系我们，帮您解决问题。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>4.2删除您的个人信息</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> 4.2.1在以下情形中，您可以向我们提出删除个人信息的请求：</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> （1）如果我们处理个人信息的行为违反法律法规；</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> （2）如果我们收集、使用您的个人信息，却未征得您的同意；</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> （3）如果我们处理个人信息的行为违反了与您的约定；</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> （4）如果您不再使用我们的产品或服务，或您注销了账号；</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> （5）如果我们不再为您提供产品或服务。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>\n' +
      '        4.2.2您可以通过识道网络官方客服联系我们，提供相关信息后，我方会帮您删除用户信息。为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。如我方停止运营或停止提供相关服务，我方将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，对所持有的个人信息进行删除或匿名化处理。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>4.3用户信息授权撤回</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> 4.3.1我方每个业务功能需要一些基本的个人信息才能得以完成（见本隐私权政策)。除此之外：您可以通过修改个人设置的方式撤回部分授权，也可以通过关闭功能的方式撤销授权。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>\n' +
      '        4.3.2请您理解，每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我方无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>4.4账号注销</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>\n' +
      '        如果您决定停止使用识道网络，则您可以对您的账号进行注销，通过常用安全设备向我们提交账户注销申请，也可以通过电话联系我们。在您注销账号前，我们会要求您进行必要的身份验证，包括个人身份（个人敏感信息）、安全状态、设备信息等。您知悉并理解，注销账号的行为是不可逆的行为，在您注销账号后，我们将停止为您提供服务，并将删除有关您账号的一切信息或对相关信息进行匿名化处理，但法律法规另有规定的除外。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>五、我方如何存储和保护您的个人信息</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>5.1您个人信息的存储 </p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> 5.1.1 您的个人信息将全被存储于中华人民共和国境内。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> 5.1.2 如果我方终止服务或运营，我们会采取合理措施保护您用户信息安全，包括及时停止继续收集用户信息的活动；停止运营的通知将以逐一送达或公告的形式通知用户；并对所持有的个人信息进行删除或匿名化处理等。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> 5.1.3 除非获得您的特别同意，或者满足法律规定的评估及许可程序，我方不会跨境转移您的个人信息。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>5.2我方非常重视个人信息安全，并采取一切合理可行的措施，保护您的个人信息：</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> 5.2.1\n' +
      '        我方会采取适当的、符合业界标准的安全措施和技术手段，以保护您的个人信息，包括但不限于制定了严格的内部信息管理流程、对数据进行加密、定岗定责、举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识、控制访问权限、采取安全措施等，以防止其丢失、被非法使用、受到未授权访问或泄漏、被篡改或毁坏。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> 5.2.2\n' +
      '        我方仅允许有必要知晓这些信息的识道网络及识道网络关联方的员工、合作伙伴访问个人信息，并为此设置了严格的访问权限控制和监控机制。我方同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与识道网络的合作关系。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> 5.2.3\n' +
      '        为了保护您的信息安全，如果您的个人信息有误，我方会在严格验证并核实申请人身份后，根据您的要求访问、修正或删除相关信息（除非我方出于合法的原因而必须保留这些个人信息）同时按照相关法律法规规定，采取必要的安全措施和技术手段对于收集的个人生物识别信息和个人身份信息予以保护。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> 5.2.4\n' +
      '        如果一旦发生安全事件影响到您的个人信息安全的，我方将通过您预留电话、系统推送等方式通知您，并告知您降低或防范相关风险的建议等信息。必要时，我方将根据适用的法律、法规通知主管部门。同时，我方会及时处置系统漏洞、网络攻击、病毒侵袭及网络侵入等安全风险。在发生危害网络安全的事件时，我方会按照网络安全事件应急预案，及时采取相应的补救措施，并按照规定向有关主管部门报告。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p> 5.2.5 如果您对我方的个人信息保护有任何疑问，可通过本政策上的联系方式联系我方。如您发现自己的个人信息泄密，尤其是您的账户及密码发生泄露，请您立即通过本政策提供的联系方式联络我方，以便我方采取相应措施。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>六、免责声明(重要条款，请仔细阅读)</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>6.1 当您以适当的方式开始、继续使用我方的产品或服务超过15日的，您未通过适当的方式联系我方并表达相反意见的，我方将视为您充分理解并同意本政策。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>6.2 请您理解，互联网并非绝对安全的环境，电子邮件、即时通讯、社交平台、交易平台等与其他用户的交流方式无法确定是否完全加密，请您在进行交互使用时，注意保护您个人信息的安全。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>6.3\n' +
      '        请您理解，由于计算机及互联网技术的飞速发展及同步速度的限制，可能存在或出现各种恶意或非恶意的攻击手段。虽然我方持续致力于提升和加强安全措施，以保护您的个人信息免遭意外或破坏，但仍无法始终保证您的个人信息的百分之百安全。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>6.4\n' +
      '        请您理解，您使用产品或服务时所用的系统和通讯网络，或硬件设备等我方均无法控制，请您了解并注意保护您的个人信息安全。除非本隐私政策有其他规定，为了保护您的账户安全，我方特别提醒您不要通过公共网络，向我方或任何以我方名义为您提供服务的第三方，提供您的财产状况、账户密码或验证码等信息。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>七、我方如何处理未成年人的个人信息</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>我方的产品、网站和服务主要面向成人，未成年人不得创建自己的用户账户。如果我们发现自己收集了未成年人的个人信息，则会设法尽快删除相关数据。</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>八、通知和修订</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>\n' +
      '        为给您提供更好的服务以及随着我方业务的发展，本隐私政策也会随之更新。但未经您明确同意，我方不会削减您依据本隐私政策所应享有的权利。对于重大变更，我方还提供更为显著的通知方式提醒您，也请您访问我方时了解最新的隐私政策。本政策所指的重大变更包括但不限于：</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>（1）我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>（2）我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>（3）个人信息共享、转让或公开披露的主要对象发生变化；</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>（4）您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>（5）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>（6）个人信息安全影响评估报告表明存在高风险时。&nbsp;</p>\n' +
      '    <p>&nbsp;</p>\n' +
      '    <p>&nbsp;</p>'
};
